import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
      authority: 'https://login.microsoftonline.com/ef1e2997-5298-410a-9f78-91b5c20917ee',
      clientId: '2784d88e-1399-4cdc-895b-1694f1b015fe',
      redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
      postLogoutRedirectUri: "/", 
      navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      allowNativeBroker: false // Disables WAM Broker
    }
};

export const loginRequest: RedirectRequest = {
  scopes: ["User.Read"]
};